import { render, staticRenderFns } from "./CapacityLoggerList.vue?vue&type=template&id=f1dd0674&scoped=true"
import script from "./CapacityLoggerList.vue?vue&type=script&lang=js"
export * from "./CapacityLoggerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1dd0674",
  null
  
)

export default component.exports